import React, { useState } from 'react'

const EYE_OPENING_INSIGHTS = 'Extract eye-opening insights and surprising facts.'
const STEP_BY_STEP_TUTORIALS = 'Extract step-by-step instructions and how-to segments.'
const KEY_TAKEAWAYS = 'Extract key takeaways and main conclusions.'

import './RepurposeInstructions.scss'

interface RepurposeInstructionsProps {
  readonly repurposeInstructions: string | undefined
  setRepurposeInstructions(newRepurposeInstructions: string | undefined): void
}

const RepurposeInstructions: React.FC<RepurposeInstructionsProps> = props => {
  const {
    repurposeInstructions,
  } = props

  const [inputOpened, setInputOpened] = useState(false)
  const hasNoInstructions = !repurposeInstructions

  const handleSetInstructions = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newInstructions = e.target.value
    props.setRepurposeInstructions(newInstructions)
  }

  const setInstructionsToEyeOpeningInsights = () => {
    props.setRepurposeInstructions(EYE_OPENING_INSIGHTS)
  }

  const setInstructionsToStepByStepTutorial = () => {
    props.setRepurposeInstructions(STEP_BY_STEP_TUTORIALS)
  }

  const setInstructionsToKeyTakeaways = () => {
    props.setRepurposeInstructions(KEY_TAKEAWAYS)
  }

  const handleOpenInput = () => {
    setInputOpened(true)
  }

  const handleBlur = () => {
    if (repurposeInstructions?.trim() === '' || !repurposeInstructions) {
      props.setRepurposeInstructions(undefined)
      setInputOpened(false)
    }
  }

  return (
    <div className="RepurposeInstructions">
      <div className="SetupProjectPopup__section-header">
        Instructions (optional)
      </div>
      {hasNoInstructions && !inputOpened ? (
        <div
          className="RepurposeInstructions__placeholder"
          onClick={handleOpenInput}
        >
          What kind of clips should we extract? E.g. "
          <span
            className="RepurposeInstructions__autofill"
            onClick={setInstructionsToEyeOpeningInsights}
          >
            Eye-opening insights
          </span>
          ", "
          <span
            className="RepurposeInstructions__autofill"
            onClick={setInstructionsToStepByStepTutorial}
          >
            Step-by-step tutorial
          </span>
          ", "
          <span
            className="RepurposeInstructions__autofill"
            onClick={setInstructionsToKeyTakeaways}
          >
            Key takeaways
          </span>
          "... (Optional - Auto-detect by default)
        </div>
      ) : (
        <div className="RepurposeInstructions__input-wrapper">
          <textarea
            className="RepurposeInstructions__input"
            autoFocus
            value={repurposeInstructions}
            onChange={handleSetInstructions}
            onBlur={handleBlur}
            rows={3}
          />
        </div>
      )}
    </div>
  )
}

export default RepurposeInstructions
